import { formatCompact } from '@utils/currency';

/** `1234567` → `12l` for an INR org, `1.2m` for AED; lower-cased as the demand tiles read it. */
export const formatCompactNumber = (value?: number | null): string => {
    if (typeof value !== 'number' || Number.isNaN(value)) return '—';
    return formatCompact(value).toLowerCase();
};

